<template>
    <input
        :value="value"
        :type="type"
        :readonly="readonly"
        @input="input"
        @blur="blur"
        @change="change"
        :class="['input', inline ? '' : 'input-block', 'font-size-16 md:font-size-20']"
    />
</template>

<script>
export default {
    name: 'XInput',

    props: {
        value: {},

        inline: {
            type: Boolean,
            default: false
        },

        min: {},

        max: {},

        type: {
            type: String,
            default: 'text'
        },

        readonly: {
            type: Boolean,
            default: false
        },

        onlyNumber: {
            type: Boolean,
            default: false
        },

        decimal: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        input(e) {
            if (this.onlyNumber) {
                if (e.target.value.charAt(0) == 0 && +e.data) {
                    e.target.value = e.data
                }

                if (this.decimal) {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '')
                } else {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '')
                }
            }

            this.$emit('input', e)
        },

        blur(e) {
            var value = e.target.value

            if (this.type == 'number') {
                value = parseInt(e.target.value)
                e.target.value = value
            }

            if (value > this.max) {
                e.target.value = parseInt(this.max)
            }

            if (value < this.min) {
                e.target.value = parseInt(this.min)
            }

            this.$emit('blur', e)
        },

        change(e) {
            this.$emit('change', e)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variable.scss';

input {
    border: none;
    border-radius: 4px;
    color: $input-placeholder-color;

    &::placeholder {
        text-transform: none;
        text-align: left;
    }

    &:disabled {
        color: rgb(126, 123, 123);
        background-color: rgba($color: #eee, $alpha: 1);
        cursor: not-allowed;
    }
}
</style>
